var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconHealth64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4606 13.439C49.7276 13.439 54.8081 18.3964 54.8081 24.5117C54.8081 27.7911 53.3471 30.7375 51.0255 32.765L33.517 51.7368L16.191 32.8967C13.7805 30.8663 12.2549 27.8628 12.2549 24.5117C12.2549 18.3964 17.3353 13.439 23.6024 13.439C27.875 13.439 31.5962 15.7432 33.5318 19.1476C35.4668 15.7432 39.1879 13.439 43.4606 13.439Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 33.1197H28.1923L32.0385 26.2048L35.8846 40.0346L39.7308 33.1197H58",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2127 36.8433C55.269 36.8433 56.9361 35.1763 56.9361 33.1199C56.9361 31.0635 55.269 29.3965 53.2127 29.3965C51.1563 29.3965 49.4893 31.0635 49.4893 33.1199C49.4893 35.1763 51.1563 36.8433 53.2127 36.8433Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconHealth64);
export default __webpack_public_path__ + "static/media/pictogramBeaconHealth64.8f7800f14cac3fdc79901f8f846debea.svg";
export { ForwardRef as ReactComponent };